<template>
  <Listbox :modelValue="_modelValue" @update:modelValue="modelValueUpdated" :class="classes">
    <div class="relative">
      <label v-if="label" :for="_id" class="block mb-1 text-sm font-medium">{{ label }} </label>
      <div class="relative w-full">
        <ListboxButton class="w-full py-2 pl-4 pr-0.5 truncate border rounded-lg focus:outline-none focus:border-primary-700" :class="classes" :disabled="disabled">
          <div class="flex flex-row items-center justify-items-center">
            <span class="flex w-full truncate">{{ (_modelValue?.[itemText]) ?? null }}</span>
            <i class="grid w-10 text-gray-500 pointer-events-none material-icons-round place-items-center">unfold_more</i>
          </div>
        </ListboxButton>
      </div>
      <TransitionRoot leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
        <ListboxOptions class="absolute py-1 mt-1 overflow-auto bg-primaryGrapesJs-500 border border-primaryGrapesJs-300 rounded-lg shadow-lg z-[8] min-w-full max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div v-if="items.length === 0" class="relative px-4 py-2 text-gray-700 cursor-default select-none">Nothing found.</div>

          <ListboxOption v-for="item in items" as="template" :key="item[itemKey]" :value="item" v-slot="{ selected, active }">
            <li
              class="relative py-2 pl-10 pr-4 cursor-pointer select-none"
              :class="{
                'text-primary-900 bg-primary-100': active,
              }"
            >
              <span class="block truncate">
                {{ item[itemText] }}
              </span>
              <i v-if="selected" class="absolute inset-y-0 left-0 grid w-10 material-icons-round text-primary-900 place-items-center"> check </i>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </TransitionRoot>
    </div>
  </Listbox>
</template>

<script>

import { Listbox, ListboxButton, ListboxOptions, ListboxOption, TransitionRoot } from "@headlessui/vue"

export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: null,
      required: true,
    },
    returnKey: {
      type: Boolean,
      required: false,
    },
    id: String,
    label: String,
    items: {
      type: Array,
      default: () => [],
    },
    itemKey: {
      type: String,
      default: "key",
    },
    itemText: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _id() {
      return this.id ?? this.label?.toLowerCase().replace(/ /g, "")
    },
    _modelValue() {
      return !this.returnKey ? this.modelValue : this.items.find((each) => each[this.itemKey] === this.modelValue)
    },
    classes() {
      return {
        "bg-primaryGrapesJs-600 text-primaryGrapesJs-200 cursor-default border-primaryGrapesJs-200 rounded-lg": this.disabled,
        "bg-primaryGrapesJs-900 text-primaryGrapesJs-100 cursor-pointer border-primaryGrapesJs-300 rounded-lg": !this.disabled,
      }
    }
  },
  methods: {
    modelValueUpdated(item) {
      const value = !this.returnKey ? item : item[this.itemKey]
      this.$emit("update:modelValue", value)
    },
  },

  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    TransitionRoot,
  },
}
</script>
<style scoped>
.border-style:focus-within {
  border: rgb(220 38 38) solid 1px;
  box-shadow: 0px 0px 0px 1px rgb(220 38 38);
}
[type="text"]:focus {
  border: transparent;
  --tw-ring-color: #0000;
}
</style>
